/* istanbul ignore file */

import { handleFetchResponse } from '@noths/polaris-client-utils';
import fetch from 'isomorphic-unfetch';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/NextConfig';
import type { RecommendationsServiceProduct } from './types';

const {
  publicRuntimeConfig: { RECOMMENDED_PRODUCTS_API_URL },
} = getConfig() as NextConfig;

export const fetchRecommendedProducts = async (productIds: string[]) => {
  const idParamValues = productIds.join('&ids[]=');

  try {
    const serviceResponse = await fetch(`${RECOMMENDED_PRODUCTS_API_URL}?ids[]=${idParamValues}`);
    const { products } = ((await handleFetchResponse(serviceResponse)) || {}) as Record<
      'products',
      RecommendationsServiceProduct[]
    >;

    return products;
  } catch (error) {
    console.error(`error in fetchRecommendedProducts: ${String(error)}`);
  }

  return null;
};
